import { Module } from 'vuex'

import { PageType } from '@/domain/value_objects/frame/PageType'

interface FrameState {
  leftSideFrame: PageType
  rightSideFrame: PageType
  isHandlingSlideBar: boolean
  readonly minLeftSideFrameWidth: number
  maxLeftSideFrameWidth: number
  leftSideFrameWidth: number
}

export const frameStateModule = (): Module<FrameState, any> => {
  return {
    namespaced: true,
    state: {
      leftSideFrame: 'Problem',
      rightSideFrame: 'Editor',
      isHandlingSlideBar: false,
      minLeftSideFrameWidth: 500,
      maxLeftSideFrameWidth: window.innerWidth - 700,
      leftSideFrameWidth: window.innerWidth / 2 - 100
    },
    mutations: {
      setLeftSideFrame(state, { leftSideFrame }: { leftSideFrame: PageType }) {
        state.leftSideFrame = leftSideFrame
        if (state.maxLeftSideFrameWidth < state.leftSideFrameWidth) {
          state.leftSideFrameWidth = state.maxLeftSideFrameWidth
        }
        if (state.minLeftSideFrameWidth > state.leftSideFrameWidth) {
          state.leftSideFrameWidth = state.minLeftSideFrameWidth
        }
      },
      setRightSideFrame(state, { rightSideFrame }: { rightSideFrame: PageType }) {
        state.rightSideFrame = rightSideFrame
      },
      setIsHandlingSlideBar(state, { flag }: { flag: boolean }) {
        state.isHandlingSlideBar = flag
      },
      setLeftSideFrameWidth(state, { width }: { width: number }) {
        state.leftSideFrameWidth = width
      },
      setMaxLeftSideFrameWidth(state, { width }: { width: number }) {
        state.maxLeftSideFrameWidth = width
      }
    },
    actions: {},
    getters: {
      leftSideFrame: state => state.leftSideFrame,
      rightSideFrame: state => state.rightSideFrame,
      isHandlingSlideBar: state => state.isHandlingSlideBar,
      minLeftSideFrameWidth: state => state.minLeftSideFrameWidth,
      maxLeftSideFrameWidth: state => state.maxLeftSideFrameWidth,
      leftSideFrameWidth: state => state.leftSideFrameWidth
    }
  }
}
